/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState } from "react"
import clsx from "clsx"
import {
	IconCircleCheckOutline18 as CheckCircle2,
	IconCircleDashedOutline18 as CircleIcon,
} from "nucleo-ui-outline-18"

import { Button } from "@productlane/ui"

interface HeaderStepProps {
	hasHeader: boolean
	select: (hasHeader: boolean) => void
	cancel: () => void
	data: string[][]
}

export function HeaderStep({
	select,
	cancel,
	data,
	hasHeader: hasHeaderInitial,
}: HeaderStepProps) {
	const [hasHeader, setHasHeader] = useState(hasHeaderInitial)
	return (
		<>
			<div className="space-y-2 text-xs">
				<div
					className={clsx(
						"flex items-center gap-2 rounded border p-2 transition hover:bg-gray-200 dark:hover:bg-brand-900",
						hasHeader &&
							"border border-gray-450 bg-gray-200 dark:border-gray-700 dark:bg-gray-900",
					)}
					onClick={() => setHasHeader(true)}
				>
					<Circles enabled={hasHeader} />
					The first row are headers
				</div>
				<div
					className={clsx(
						"flex items-center gap-2 rounded border p-2 transition hover:bg-gray-200 dark:hover:bg-brand-900",
						!hasHeader &&
							"border border-gray-450 bg-gray-200 dark:border-gray-700 dark:bg-gray-900",
					)}
					onClick={() => setHasHeader(false)}
				>
					<Circles enabled={!hasHeader} />
					There are no headers
				</div>
			</div>

			<div className="mb-2 mt-4 text-sm text-primary">Preview:</div>
			<div className="relative mt-1 overflow-hidden rounded-lg border bg-white p-2 dark:bg-gray-900">
				<table>
					<tbody>
						<tr className="border-b">
							{hasHeader &&
								data[0]?.map((it, i) => (
									<th
										className="max-w-[100px] truncate px-1 text-left text-sm text-primary"
										key={`header-${i}`}
									>
										{it}
									</th>
								))}
							{!hasHeader && (
								<th colSpan={3} className="text-left">
									No Headers
								</th>
							)}
						</tr>
						{data.slice(hasHeader ? 1 : 0, hasHeader ? 4 : 3).map((row, i) => (
							<tr key={`row-${i}`}>
								{row.map((it, j) => (
									<td
										className="max-w-[100px] truncate px-1 text-xs text-secondary"
										key={`field-${i}-${j}`}
									>
										{it}
									</td>
								))}
							</tr>
						))}
					</tbody>
				</table>
				<div className="absolute inset-x-0 bottom-0 h-[80%] bg-gradient-to-b from-transparent via-white/80 to-white dark:via-brand-900/80 dark:to-brand-900" />
			</div>

			<div className="mt-2 flex w-full justify-between">
				<Button variant="ghost" onClick={cancel}>
					Cancel
				</Button>
				<Button onClick={() => select(hasHeader)}>Select</Button>
			</div>
		</>
	)
}

function Circles({ enabled }: { enabled: boolean }) {
	if (enabled) {
		return <CheckCircle2 className="h-4 w-4 text-gray-500" />
	}

	return <CircleIcon className="h-4 w-4 text-gray-300" />
}
